import { t } from '@/i18n';
import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';

export const breadcrumb: BreadcrumbInfoItems = [
  {
    label: t('pages.application_predictions.breadcrumb.predictions_label1'),
    link: '/application',
  },
  {
    label: t('pages.application_predictions.breadcrumb.predictions_label2'),
    link: '/application/interactive-area',
  },
  {
    label: t('pages.application_predictions.breadcrumb.predictions_label3'),
  },
];
